import { SolAvatarSize, SolViewId, SolViewOptions } from '@sol/components';

// summary: the Notes row itself, "No notes" when empty; list: the notes under it, full width
export type WebContentNotesViewPart = 'summary' | 'list';

export interface WebContentNotesViewOptions extends SolViewOptions {
  part: WebContentNotesViewPart;
  size: SolAvatarSize;
  canDeleteAnnotation: boolean;
  expanded: boolean;
}

export class WebContentNotesViewId {
  public static readonly notes = SolViewId.of<WebContentNotesViewOptions>('webContentV2.notes', {
    part: 'summary',
    size: 'default',
    canDeleteAnnotation: false,
    expanded: false,
  });
}
